<template>
    <li :class="['tree', 'tree-node', {'tree-closed': !isOpen, 'tree-open': isOpen}]">
        <span class="title">
            <feather-icon @click="toggle" :icon="isFolder ? 'ChevronRightIcon' : ''" :class="{'rotate90' : isOpen}" ></feather-icon>
            <div :class="['tree-anchor', {'selected-node': item.selected }]"
               @click="select">
                <feather-icon v-if="item.icon" :icon="item.icon" ></feather-icon>
                <VxTooltip v-if="item.tooltip" :title="item.tooltip.title" :text="item.tooltip.text" position="top">
                    <span v-html="item.title" style="white-space: nowrap;"></span>
                </VxTooltip>
                <span v-else v-html="item.title" style="white-space: nowrap;"></span>
            </div>
        </span>
        <ul v-show="isOpen" v-if="isFolder" class="tree-container-ul tree-children">
            <TreeItem
                    class="item"
                    v-for="(child, index) in item.children"
                    :key="index"
                    :item="child"
                    @selected="$emit('selected', $event)"
                    @toggle="$emit('toggle', $event)"
            ></TreeItem>
        </ul>
    </li>
</template>

<script>
    export default {
        name: "TreeItem",
        props: {
            item: Object,
        },
        data: function () {
            return {
                isOpen: false
            }
        },
        computed: {
            isFolder: function () {
                return this.item.children &&
                    this.item.children.length
            }
        },
        methods: {
            toggle: function () {
                if (this.isFolder) {
                    this.isOpen = !this.isOpen
                }
                this.$emit('toggle', this.item);
            },
            select: function () {
                if (!this.isFolder) {
                    this.isOpen = true
                }
                this.$emit('selected', this.item);
            }
        }
    }
</script>

<style>
    .tree-node, .tree-children, .tree-container-ul {
        display: block;
        padding-left: 0.7em;
        line-height: 1.5em;
        list-style-type: dot;
    }
    .tree .tree-open > .tree-children {
        display: block;
    }
    .tree .title {
        align-items: center;
        display: inline-flex;
    }
    .tree .feather-icon {
        width: 14px;
        height: 14px;
        line-height: 14px;
        text-align: center;
        -webkit-transition: all .2s ease-in-out;
        transition: all .2s ease-in-out;
    }
    .tree-anchor {
        margin: 0;
        padding: 0 4px;
        color: #515a6e;
        -webkit-transition: all .2s ease-in-out;
        transition: all .2s ease-in-out;
        line-height: 1.7em;
        align-items: center;
        display: flex;
        cursor: pointer;
    }
    .tree-anchor:hover {
        background-color: #eaf4fe;
    }
    .selected-node {
        background-color: #eaf4fe;
    }
    .tree-anchor .feather-icon {
        margin-right: 5px;
    }
</style>
